// A refusal on a plan pin nests answer, pin then attribute, deeper than one flatten level.
// React then receives an object to render, and unmounts the whole form over it.
const flattenMessages = value => {
  if (typeof value === 'string')
    return [value]
  if (Array.isArray(value))
    return value.flatMap(flattenMessages)
  if (value && typeof value === 'object')
    return Object.values(value).flatMap(flattenMessages)
  return []
}

export default flattenMessages
